<div fxLayout="row" fxLayoutAlign="center center" class="card">
  <form [formGroup]="passwordForm" (submit)="submit()" class="wideCard">
    <mat-card>
      <mat-card-header>
        <mat-card-title class="mat-h2">Enter a new password</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-form-field class="full-width">
          <input matInput type="password" placeholder="Password" formControlName="password" required>
          <mat-error *ngIf="!!passwordForm.controls.password?.errors?.shortPassword">
            Minimum password length is 8 characters.
          </mat-error>
          <mat-error *ngIf="!!passwordForm.controls.password?.errors?.weakPassword">
            Password should contain at least 3 of the following character types: Lowercase, Uppercase, Number, Punctuation.
          </mat-error>
        </mat-form-field>
        <mat-form-field class="full-width">
          <input matInput type="password" placeholder="Confirm password" formControlName="confirmPassword" required>
          <mat-error *ngIf="!passwordForm.controls.confirmPassword?.errors?.mismatchPassword">
            Passwords don't match.
          </mat-error>
        </mat-form-field>
      </mat-card-content>
      <mat-card-actions align="end">
        <button mat-raised-button color="primary" [disabled]="!passwordForm.valid">Set password</button>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
